"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingTableOfContents = void 0;
class FloatingTableOfContents {
    floatingToc;
    article;
    articleRect;
    sections = [];
    tocLinks;
    constructor() {
        this.floatingToc = document.getElementById('floating-toc');
        this.article = document.querySelector('article.prose');
        this.articleRect = this.article?.getBoundingClientRect() || null;
        this.tocLinks = this.floatingToc?.querySelectorAll('a') || null;
        if (!this.floatingToc || !this.article)
            return;
        this.initializeSections();
        this.setupEventListeners();
        this.highlightCurrentSection();
    }
    initializeSections() {
        if (!this.tocLinks)
            return;
        this.tocLinks.forEach((link) => {
            const href = link.getAttribute('href');
            if (!href)
                return;
            const id = href.substring(1);
            const element = document.getElementById(id);
            if (element) {
                this.sections.push({ id, element, link });
            }
        });
    }
    highlightCurrentSection() {
        if (!this.tocLinks)
            return;
        const scrollPosition = window.scrollY + 100; // Add offset for better highlighting
        for (let i = 0; i < this.sections.length; i++) {
            const section = this.sections[i];
            const nextSection = this.sections[i + 1];
            const sectionTop = section.element.offsetTop;
            const sectionBottom = nextSection ? nextSection.element.offsetTop : Infinity;
            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                this.tocLinks.forEach((link) => link.classList.remove('active'));
                section.link.classList.add('active');
                break;
            }
        }
    }
    setupEventListeners() {
        window.addEventListener('scroll', () => this.highlightCurrentSection());
    }
}
exports.FloatingTableOfContents = FloatingTableOfContents;
